import React from 'react';
import { Icon } from '@iq/react-components';
import { STATUSES } from '../../../../constants';

function getIcon(risk) {
  switch (risk) {
    case 'High': {
      return STATUSES.r3;
    }
    case 'Medium': {
      return STATUSES.r2;
    }
    // Not being used currently
    // case 'Low':
    default: {
      return STATUSES.r1;
    }
  }
}

const quickFilterTitle = (properties) => {
  const { label, children } = properties;

  const { color, icon } = getIcon(label);
  const [r, g, b] = color;

  return (
    <div className={`filter-risk-level ${label === 'Low' ? 'filter-low-risk' : ''}`}>
      {children}
      <Icon
        size="s"
        icon={icon}
        style={{ color: `rgba(${r}, ${g}, ${b}, ${color ? 1 : 0})` }}
      />
      <label className="risk-label">{label}</label>
    </div>
  );
};

const schema = {
  type: 'object',
  properties: {
    riskLevels: {
      type: 'object',
      title: 'Risk Levels',
      properties: {
        showHighRisk: {
          type: 'boolean',
          title: 'High',
          default: true,
        },
        showMediumRisk: {
          type: 'boolean',
          title: 'Medium',
          default: true,
        },
        showLowRisk: {
          type: 'boolean',
          title: `Low`,
          default: true,
        },
      },
    },
  },
};

const uiSchema = {
  riskLevels: {
    showLowRisk: {
      'ui:FieldTemplate': quickFilterTitle,
    },
    showMediumRisk: { 'ui:FieldTemplate': quickFilterTitle },
    showHighRisk: { 'ui:FieldTemplate': quickFilterTitle },
  },
};

export { schema, uiSchema };
